import React, { useState, useEffect } from "react";
import axios from "axios";
import AboutPlaceholder from "./placeholders/AboutPlaceholder";
import { useSelector } from "react-redux";
import { getContent } from "../../../utils/main";

const About = () => {
  const [about, setAbout] = useState(null);
  const [aboutLoading, setAboutLoading] = useState(true);
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/main/mainabout/`)
      .then((res) => {
        setAbout(res.data);
      })
      .then(() => {
        setAboutLoading(false);
      });
  }, []);

  return (
    <div className="about-wrapper">
      <div className="container">
        {aboutLoading === true ? (
          <div className="row">
            <AboutPlaceholder />
          </div>
        ) : (
          <div className="row">
            <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 left">
              <img
                src={process.env.REACT_APP_API_URL + about.image}
                width="100%"
                alt="About"
              />
            </div>
            <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12 right">
              <h4>
                {lang === "en"
                  ? about.name_en
                  : lang === "ru"
                  ? about.name_ru
                  : about.name_tm}
              </h4>
              <div className="main-about-wrapper position-relative">
                <div
                  className={`main-about-text ${
                    showMore === true ? "showMore" : ""
                  }`}
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === "en"
                        ? about.content_en
                        : lang === "ru"
                        ? about.content_ru
                        : about.content_tm,
                  }}
                ></div>
                <div className="overlay"></div>
              </div>
              <button
                className="clear-btn black-btn"
                onClick={() => {
                  setShowMore(!showMore);
                }}
              >
                {getContent(
                  content,
                  showMore === true ? "See Less" : "See More",
                  lang
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default About;
